<template>
  <header class="roam-header-component header-component">
    <dx-toolbar class="header-toolbar" :ref="'toolBarContent'">
      <!-- v-bind:class="[tabs.length != 0 && !isXSmall ? 'header-toolbar-with-tabs' : 'header-toolbar-no-tabs']" -->
      <dx-item
        :visible="menuToggleEnabled"
        location="before"
        css-class="menu-button"
      >
        <!-- eslint-disable vue/no-unused-vars -->
        <dx-button styling-mode="text" @click="toggleMenuFunc" slot-scope="_" />
        <!--icon="menu" -->
        <!-- eslint-enable -->
      </dx-item>
      <dx-item
        :visible="backButtonEnabled"
        location="before"
        css-class="menu-button back-button"
      >
        <!-- eslint-disable vue/no-unused-vars -->
        <dx-button
          icon="arrowleft"
          styling-mode="text"
          @click="performBackFunction"
          slot-scope="_"
          :visible="backButtonEnabled"
        />
        <!-- eslint-enable -->
      </dx-item>
      <dx-item location="before" css-class="header-right-content">
        <div slot-scope="_">
          <!-- eslint-enable -->
          <gc-header-right
            :showTabs="showTabs"
            :options="tabOptions"
            :selectedIndex="selectedIndex"
          >
            <slot name="headerContent" />
          </gc-header-right>
        </div>
      </dx-item>

      <dx-item
        :visible="profileMenuEnabled"
        location="after"
        locate-in-menu="auto"
        menu-item-template="menuUserItem"
        v-if="roamType == 'list'"
      >
        <div slot-scope="_">
          <span v-if="companyNameVisibleInToolbar">
            {{ companyName }}
          </span>
        </div>
      </dx-item>

      <dx-item
        :visible="profileMenuEnabled"
        location="after"
        locate-in-menu="auto"
        menu-item-template="menuUserItem"
        v-if="roamType == 'list'"
      >
        <div slot-scope="_">
          <dx-button
            class="user-button authorization"
            height="100%"
            styling-mode="text"
          >
            <gc-user-panel
              :menu-items="userMenuItems"
              :isXSmall="isXSmall"
              menu-mode="context"
            />
          </dx-button>
        </div>
      </dx-item>
      <gc-user-panel
        :visible="profileMenuEnabled"
        :menu-items="userMenuItems"
        menu-mode="list"
        slot-scope="_"
        slot="menuUserItem"
        v-if="roamType == 'list'"
      />

      <DxItem
        location="after"
        locate-in-menu="auto"
        widget="dxSelectBox"
        :options="headerConfig.data.multiViewOption"
        v-if="
          roamType != 'list' &&
          headerConfig &&
          headerConfig.options.multiViewSelect
        "
      />

      <DxItem
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
        :options="headerConfig.data.addNew"
        v-if="roamType != 'list' && headerConfig && headerConfig.options.addNew"
        cssClass="roam-header-add-new-btn"
      />
    </dx-toolbar>
  </header>
</template>

<script>
// import auth from "../auth";

import GcUserPanel from "./gc-user-panel";
import GcHeaderRight from "./gc-header-right";
// import { TokenStorage } from "../_services/storage";
import { authComputed } from "../_store/helpers";
import { mapGetters } from "vuex";
import BrowserHelper from "../_helpers/browser/browser-helper";
import { FeatureStorage } from "@/_services/storage";

let browserHelper = new BrowserHelper();

export default {
  props: {
    isXSmall: Boolean,
    isLarge: Boolean,
    menuToggleEnabled: Boolean,
    backButtonEnabled: {
      type: Boolean,
      default: false,
    },
    profileMenuEnabled: {
      type: Boolean,
      default: true,
    },
    title: String,
    toggleMenuFunc: {
      type: Function,
      default: function () {},
    },
    backButtonFunc: {
      type: Function,
      default: function () {},
    },
    logOutFunc: Function,
    baseView: Object,
    selectedIndex: Number,
    tabs: {
      type: Array,
      default: function () {
        return [];
      },
    },
    headerConfig: {
      type: Object,
      default: () => {},
    },
    roamType: {
      type: String,
      default: "list",
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    baseView: function (newVal, oldVal) {},
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.setApplicationMode(this.applicationMode);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    ...authComputed,
    ...mapGetters({
      applicationMode: "profile/applicationMode",
      companyName: "profile/companyName",
    }),
    companyNameVisibleInToolbar() {
      return !this.isXSmall;
    },
    showTabs() {
      return this.tabs.length > 0;
    },
    visibleTabs() {
      let tabs = this.tabs;
      tabs.forEach((x) => {
        if (
          !FeatureStorage.checkPermission(x.applicationFeatureCode, "review")
        ) {
          x.visible = false;
        }
      });

      return tabs;
    },
    tabOptions() {
      return {
        dataSource: this.visibleTabs,
        onItemClick: this.itemClick,
        selectedIndex: this.selectedIndex,
        showNavButtons: true,
        scrollByContent: true,
        width: this.isXSmall ? this.calculatedTabWidth + "px" : "auto",
        visible: this.isMobileMode
          ? true
          : this.applicationMode == "GcorpRoam"
          ? false
          : true,
      };
    },
    userMenuItems() {
      let result = this.menuItems;

      if (this.isXSmall) {
        result = this.menuItems
          .slice(0)
          .filter((x) => x.group !== "GcorpRoamOnly");
        result.unshift({
          text: this.currentUser,
          icon: "",
        });
      }

      return result;
    },

    menuItems() {
      return this.menuItemData;
    },
  },

  data() {
    return {
      calculatedTabWidth: window.innerWidth - 100,
      isMobileMode: browserHelper.mobile,
      setCompanyName: null,
      menuItemData: [
        // {
        //   text: this.companyName, // company name
        //   icon: "",
        // },
        {
          template: "separator",
        },
        {
          text: "Menu",
          group: "GcorpRoamOnly",
        },
        {
          text: "Gcorp",
          icon: "check",
          onClick: this.onGcorpMenuClick,
          name: "menuGcorp",
          group: "GcorpRoamOnly",
        },
        {
          text: "Gcorp Roam",
          icon: "noicon",
          onClick: this.onGcorpRoamMenuClick,
          name: "menuGcorpRoam",
          group: "GcorpRoamOnly",
        },
        {
          template: "separator",
          group: "GcorpRoamOnly",
        },
        {
          text: "Logout",
          icon: "runner",
          onClick: this.onLogoutClick,
        },
      ],
    };
  },
  methods: {
    performBackFunction() {
      this.$logger.trackEventButtonClickBack();
      this.backButtonFunc();
    },
    onLogoutClick() {
      this.$logger.trackEventButtonClick("Logout");
      this.$store.dispatch("authentication/logout");
    },
    onGcorpMenuClick() {
      this.setApplicationMode("Gcorp");
      this.$store.dispatch("profile/setApplicationMode", "Gcorp");
    },
    onGcorpRoamMenuClick() {
      this.setApplicationMode("GcorpRoam");
      this.$store.dispatch("profile/setApplicationMode", "GcorpRoam");
    },
    setApplicationMode(mode) {
      if (mode.replace(/[^a-zA-Z ]/g, "") == "Gcorp") {
        let menuGcorp = this.menuItems.find((x) => x.name == "menuGcorp");
        menuGcorp.icon = "check";
        let menuGcorpRoam = this.menuItems.find(
          (x) => x.name == "menuGcorpRoam"
        );
        menuGcorpRoam.icon = "noicon";
      } else {
        let menuGcorp = this.menuItems.find((x) => x.name == "menuGcorp");
        menuGcorp.icon = "noicon";
        let menuGcorpRoam = this.menuItems.find(
          (x) => x.name == "menuGcorpRoam"
        );
        menuGcorpRoam.icon = "check";
      }
    },
    itemClick(e) {
      if (e.itemData.path == "") {
        return;
      }

      // eslint-disable-next-line no-debugger
      this.$router.push({
        path: e.itemData.path,
      });
    },
    handleResize(e) {
      if (e != null) {
        // eslint-disable-next-line no-console
        // this.$logger.debug("Resize Event: ", e.srcElement.innerWidth);
        this.calculatedTabWidth = e.srcElement.innerWidth - 100;
      }
      this.$store.dispatch(
        "ui/toolBarHeight",
        this.$refs["toolBarContent"].$el.clientHeight
      );
    },
  },
  mounted() {
    this.handleResize(null);
    this.$store.dispatch("profile/setCompanyName");

    this.menuItemData.unshift({
      text: this.companyName,
      icon: "",
    });
  },

  components: {
    GcUserPanel,
    GcHeaderRight,
  },
};
</script>

<style lang="scss">
@import "../assets/styles/variables.base.scss";
// @import "../v1/assets/styles/global.scss";
@import "@/assets/styles/gc-variables.scss";

.roam-header-component {
  flex: 0 0 auto;
  z-index: 2;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

  .dx-toolbar .dx-toolbar-item.menu-button > .dx-toolbar-item-content .dx-icon {
    color: $base-accent;
  }
  // }

  .dx-toolbar.header-toolbar .dx-toolbar-items-container .dx-toolbar-after {
    padding: 0 10px;

    .screen-x-small & {
      padding: 0 20px;
    }
  }

  .dx-toolbar .dx-toolbar-item.dx-toolbar-button.menu-button {
    width: $side-panel-min-width;
    text-align: center;
    padding: 0;
  }

  .header-title .dx-item-content {
    padding: 0;
    margin: 0;
  }

  .dx-theme-generic {
    .dx-toolbar {
      padding: 10px 0;
    }

    .user-button > .dx-button-content {
      padding: 3px;
    }
  }

  .header-top {
    padding-left: 5px;
  }

  .header-toolbar .back-button .dx-icon {
    color: rgb(128, 128, 128) !important;
  }

  .menu-button .dx-icon-menu {
    display: none !important;
  }

  .dx-toolbar .dx-toolbar-items-container {
    height: 65px !important;
  }

  .header-right .header-top {
    margin-bottom: 0;
  }

  .header-right .header-bottom {
    margin-bottom: 18px;
  }

  .header-toolbar .back-button {
    width: 40px !important;
  }
  .screen-x-small {
    .header-toolbar
      .dx-toolbar-items-container
      .dx-toolbar-before
      .dx-state-invisible.dx-item.dx-toolbar-item.dx-toolbar-button.menu-button.back-button {
      width: 0px !important;
    }
  }

  .header-top {
    padding-left: 0;
    .text-primary {
      margin-left: 0;
    }
  }

  .header-toolbar
    .dx-toolbar-items-container
    .dx-toolbar-before
    .dx-state-invisible.dx-item.dx-toolbar-item.dx-toolbar-button.menu-button.back-button {
    display: block !important;
    width: 10px !important;
    .dx-button .dx-button-content {
      display: none;
    }
  }

  .header-toolbar.header-toolbar-with-tabs {
    .back-button {
      display: block;
      padding-top: 4px !important;
    }
  }

  #navigation-header
    .dx-toolbar-items-container
    .menu-button
    .dx-button
    .dx-button-content {
    background-image: url("../../public/statics/CX-Favicon.png");
    resize: both;
    background-repeat: no-repeat;
    background-size: 24px 24px;
    margin: auto;
    background-position: center center;
  }

  .text-primary {
    font-size: 13px;
    font-weight: 400;
    letter-spacing: normal;
  }

  .text-secondary {
    font-size: 12px;
    letter-spacing: normal;
    color: #807878 !important;
  }

  #navigation-header {
    background-color: #363640 !important;
  }

  #navigation-header .dx-toolbar-items-container {
    height: 40px !important;
  }

  .header-toolbar-no-tabs .dx-toolbar-items-container {
    height: 40px !important;
  }
  .dx-toolbar-item-invisible {
    display: table-cell !important;
  }

  .dx-toolbar-button.dx-toolbar-menu-container {
    display: none !important;
  }

  .roam-header-add-new-btn {
    .dx-button {
      background-color: #03a9f4 !important;
      color: #fff !important;
      .dx-button-content .dx-icon::before {
        color: #fff !important;
      }
    }
  }
}
</style>
